import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import RouterWrapper from './Router/index'
import { ThemeProvider } from '../src/Components/ThemeProvider'
import './styles/variables.css'

export const ENV = process.env.REACT_APP_ENV

class App extends PureComponent {
  render() {
    return (
      <ThemeProvider>
        <RouterWrapper admin={this.props.admin} />
      </ThemeProvider>
    )
  }
}

const mapStateToProps = state => ({
  admin: [1, 2].includes(state.login.tipoUser)
})

export default connect(mapStateToProps)(App)